import type { ClaimsSlide } from "./types";
export type { ClaimsSlide } from "./types";

export const visibleClaimsSlides = (
  slides: ClaimsSlide[],
  make?: string
) => {
  const normalise = (value?: string) =>
    typeof value === "string"
      ? value.trim().toLowerCase().replace(/\s+/g, " ")
      : "";
  const aliases: Record<string, string[]> = {
    maruti: ["maruti", "maruti suzuki", "maruti suzuki india", "maruti suzuki india limited"],
    hyundai: ["hyundai", "hyundai motor india", "hyundai motor india limited"],
    tata: ["tata", "tata motors", "tata motors limited"]
  };
  const brand = Object.keys(aliases).find(key => aliases[key].includes(normalise(make)));
  return slides.filter((slide) => {
    if (slide.audience === "maruti")
      return [
        "maruti",
        "maruti suzuki",
        "maruti suzuki india",
        "maruti suzuki india limited"
      ].includes(normalise(make));
    return true;
  }).map(slide => ({
    ...slide,
    title: (brand && slide.titlesByMake?.[brand]) || slide.title
  }));
};
